export default __webpack_public_path__ + "static/media/todo-list.9cd96db2.jpg";